import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Dropdown, Avatar, Button, Tooltip, theme } from "antd";
import {
  MenuOutlined,
  MoonOutlined,
  SunOutlined,
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
  ApiOutlined,
} from "@ant-design/icons";
import { LOGOUT } from "../../redux/actions/authActions";
import { SET_THEME } from "../../redux/actions/commonActions";
import axiosLLInstance from "../../utils/axiosLLInstance";
import logo from "../../images/logo.jpg";
import smallLogo from "../../images/small_logo.png";
import { Role } from "../../utils/constants";
import LinearProgress from "./LinearProgress";

const { Header: AntHeader } = Layout;

const Header = ({ handleToggle, activeSidebar }) => {
  const [displayPicture, setDisplayPicture] = useState("./images/default.jpeg");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    token: { colorBgContainer, colorText, colorBorder, boxShadowSecondary },
  } = theme.useToken();

  const { email, name, role, image } = useSelector((state) => state.auth);
  const { linearLoading, isDarkMode } = useSelector((state) => state.common);

  useEffect(() => {
    setDisplayPicture(
      image
        ? `${process.env.REACT_APP_API_URL}/profile_img/${image}`
        : "./images/default.jpeg"
    );
  }, [image]);

  const handleLogout = async () => {
    try {
      await axiosLLInstance.post(`/auth/logout`, { email });
      dispatch(LOGOUT());
      navigate("/login");
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  const getRoleName = (role) => {
    switch (role) {
      case Role.SUPERADMIN:
        return "Super Admin";
      case Role.ADMIN:
        return "Admin";
      default:
        return "User";
    }
  };

  const menuProps = {
    items: [
      {
        key: "profile",
        icon: <UserOutlined />,
        label: <Link to="/profile">My Profile</Link>,
      },
      {
        key: "settings",
        icon: <SettingOutlined />,
        label: <Link to="/settings">Settings</Link>,
      },
      {
        key: "api",
        icon: <ApiOutlined />,
        label: <Link to="/api-docs">API Docs</Link>,
      },
      {
        type: "divider",
      },
      {
        key: "logout",
        icon: <LogoutOutlined />,
        danger: true,
        label: "Logout",
        onClick: handleLogout,
      },
    ],
  };

  return (
    <>
      <AntHeader
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          background: colorBgContainer,
          borderBottom: `1px solid ${colorBorder}`,
          boxShadow: boxShadowSecondary,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 24px",
          height: 64,
          lineHeight: "64px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            whiteSpace: "nowrap",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={handleToggle}
            aria-label="Toggle sidebar"
            style={{ padding: 0, height: 40, lineHeight: "40px" }}
          />
          <img
            src={activeSidebar ? logo : smallLogo}
            alt="Logo"
            style={{
              height: 40,
              display: "block",
              backgroundColor: "transparent",
              borderRadius: 6,
              padding: 4,
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            whiteSpace: "nowrap",
          }}
        >
          {/* <Tooltip>
            {isDarkMode ? (
              <SunOutlined
                onClick={() => dispatch(SET_THEME())}
                style={{
                  color: "#fff",
                  fontSize: 20,
                  cursor: "pointer",
                  lineHeight: 1,
                }}
              />
            ) : (
              <MoonOutlined
                onClick={() => dispatch(SET_THEME())}
                style={{
                  color: "#000",
                  fontSize: 20,
                  cursor: "pointer",
                  lineHeight: 1,
                }}
              />
            )}
          </Tooltip> */}

          <Dropdown
            menu={menuProps}
            placement="bottomRight"
            trigger={["click"]}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  textAlign: "right",
                  lineHeight: "1.2",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: colorText,
                    fontSize: 14,
                    whiteSpace: "nowrap",
                  }}
                >
                  {name}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#b0b0b0",
                    whiteSpace: "nowrap",
                  }}
                >
                  {getRoleName(role)}
                </div>
              </div>
              <Avatar src={displayPicture} size={40} alt="Profile" />
            </div>
          </Dropdown>
        </div>
      </AntHeader>

      {linearLoading && <LinearProgress />}
    </>
  );
};

export default Header;
